import { Sparkles } from "lucide-react";

const ITEMS = [
  "Cristo Redentor",
  "Pão de Açúcar",
  "Mirante Dona Marta",
  "Escadaria Selarón",
  "Santa Teresa",
  "Transfer incluso",
  "Roteiros sob medida",
  "Cadastur 19.967376.16-7",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <section
      aria-hidden="true"
      className="overflow-hidden border-y border-white/10 bg-[#161B22] py-5"
    >
      <div className="marquee-track flex w-max items-center gap-10">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className="whitespace-nowrap font-display text-sm font-bold uppercase tracking-[0.3em] text-stone-300">
              {item}
            </span>
            <Sparkles className="h-4 w-4 shrink-0 text-amber-400" />
          </span>
        ))}
      </div>
    </section>
  );
}
